module.exports = __webpack_public_path__ + "media/asset-1.6b1f26f8.webm";